<template>
  <responsive-modal v-model="visible" title="Integrar Clicksign">
    <div class="tool-modal-clicksign">
      <a
        href="https://www.clicksign.com"
        target="_blank"
        class="integration-link"
      >
        Conheça a Clicksign
        <i class="ph ph-arrow-square-out" />
      </a>
      <snow-input
        label="Token"
        id="url"
        v-model="form.token"
        :errors="errors.token"
      />
      <snow-input
        label="Descrição da integração (Opcional)"
        id="description"
        v-model="form.description"
      />
      <action-dispatcher action="product/get" :parameters="{ limit: 500 }">
        <snow-select
          id="product-select"
          label="Produto"
          v-model="form.product_id"
          :options="products"
        />
      </action-dispatcher>

      <dashed-add-resource title="Adicionar Documento">
        <input type="file" @change="addDocument($event.target.files)" />
      </dashed-add-resource>
      <div v-if="form.document.name" class="file-wrapper">
        <div class="flex-fill fs-14">
          <i class="ph ph-file" />
          <span>
            teste
            {{ form.document.name }}
          </span>
        </div>
        <snow-button class="delete-button" size="sm" @click="clearDocuments">
          Excluir
        </snow-button>
      </div>

      <div class="snow-submit-buttons">
        <snow-button
          size="lg"
          text="Cancelar"
          variant="gray"
          class="order-lg-0 order-1"
          @click="
            visible = false;
            clear();
          "
        />
        <snow-button
          size="lg"
          text="Salvar"
          :disabled="!isValid"
          :loading="loading"
          @click="submit"
        />
      </div>
    </div>
  </responsive-modal>
</template>
<script>
import DashedAddResource from "@/components/product/details/content/step02/DashedAddResource.vue";
import { formFields } from "@/functions/helpers";
import { mapState } from "vuex";
export default {
  components: { DashedAddResource },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    integrationToEdit: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      ...formFields(
        [
          "token",
          "description",
          "product_id",
          "document",
          "integration_id",
          "event_id"
        ],
        {
          document: { name: "", id: "" }
        }
      ),
      loading: false,
      visible: false,
      currentStep: 1
    };
  },
  watch: {
    value(v) {
      this.visible = v;
    },
    visible(v) {
      this.$emit("input", v);
      if (!v) {
        this.$emit("update-list");
        this.clear();
      }
    },
    integrationToEdit(v) {
      if (v) {
        this.form = {
          ...this.form,
          ...v
        };
      }
    },
    products(val) {
      if (this.integrationToEdit && this.integrationToEdit.product_name) {
        this.form.product_id = val.find(i => {
          return (
            i.name.toLowerCase() ===
            this.integrationToEdit.product_name.toLowerCase()
          );
        }).id;
      }
    }
  },
  computed: {
    ...mapState("product", ["products"]),
    isValid() {
      return this.form.product_id && this.form.document.id;
    }
  },
  methods: {
    previous() {
      this.currentStep = 1;
    },
    async next() {
      if (this.loading) return;

      this.loading = true;

      try {
        if (!this.integrationToEdit) {
          const data = await this.$store.dispatch(
            "integration/postClicksignIntegration",
            {
              token: this.form.token,
              description: this.form.description
            }
          );
          this.form.integration_id = data;
          this.currentStep = 2;
        } else {
          this.form.integration_id = this.integrationToEdit.id;
          await this.$store.dispatch("integration/putClicksignIntegration", {
            integration_id: this.form.integration_id,
            token: this.form.token,
            description: this.form.description
          });
          const data = await this.$store.dispatch(
            "integration/getClicksignEvent",
            this.form.integration_id
          );
          if (data.count) {
            this.form.event_id = data.results[0].id;
            const resp_data = await this.$store.dispatch(
              "integration/getDocument",
              {
                integration_id: this.form.integration_id,
                event_id: this.form.event_id
              }
            );
            this.form.document.name = resp_data.metadata.document_name;
            this.form.document.id = resp_data.metadata.document_id;
          }
          this.currentStep = 2;
        }
      } catch (e) {
        this.handleErrors(
          e,
          "TRANSLATE_FIELD_INTEGRATION_MAP",
          "Erro ao salvar configuração"
        );
      } finally {
        this.loading = false;
      }
    },
    addDocument(document) {
      const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
      const i = parseInt(
        Math.floor(Math.log(document[0].size) / Math.log(1024))
      );
      const size =
        Math.round(document[0].size / Math.pow(1024, i), 2) + " " + sizes[i];

      if ((size.match("MB") && /([^MB]*)MB/.exec(size)[1] > 5) || i > 2) {
        this.$message.error("O arquivo deve ter no máximo 5MB");
        return;
      }
      const reader = new FileReader();
      reader.fileName = document[0].name;

      reader.onload = e => {
        this.$store
          .dispatch("integration/createDocument", {
            integration_id: this.form.integration_id,
            file: reader.result,
            name: e.target.fileName
          })
          .then(data => {
            this.form.document.id = data.document_id;
            this.form.document.name = document[0].name;
          })
          .catch(e => {
            this.handleErrors(
              e,
              "TRANSLATE_FIELD_INTEGRATION_MAP",
              "Erro ao salvar documento"
            );
          });
      };
      reader.readAsDataURL(document[0]);
    },
    clear() {
      this.currentStep = 1;
      this.$emit("clear-edit");
      this.form = { product_id: "", document: { name: "", id: "" } };
    },
    clearDocuments() {
      this.form.document = { name: "", id: "" };
    },
    submit() {
      this.loading = true;

      const action = this.form.event_id
        ? "integration/putClicksignEvent"
        : "integration/postClicksignEvent";

      const data = {
        integration_id: this.form.integration_id,
        event_id: this.form.event_id,
        params: {
          product_id: this.form.product_id,
          metadata: {
            document_id: this.form.document.id,
            document_name: this.form.document.name
          }
        }
      };

      this.$store
        .dispatch(action, data)
        .then()
        .catch(error => {
          this.handleErrors(
            error,
            "TRANSLATE_FIELD_INTEGRATION_MAP",
            "Erro ao salvar configuração"
          );
        })
        .finally(() => {
          this.loading = false;
          this.visible = false;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.tool-modal-clicksign {
  display: flex;
  flex-direction: column;
  gap: 16px;

  .delete-button {
    background: #ff4747 !important;
  }
  .file-wrapper {
    display: flex;
    align-items: center;
    border: 1px solid #d2d0d8;
    border-radius: 16px;
    padding: 24px;
    font-size: 12px;
  }
  .delete-button {
    i {
      font-size: 24px;
      color: red;
    }
  }
}
</style>
